module.exports = "//d274d294w9cx2v.cloudfront.net/ba2989393cf19128e53ca04cfa6cbfc0cc6eee53/images/photo-couple.png";